import { Formik } from "formik";
import Loader from "../../loader";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { profileStep1Schema } from "../../../utils/schema";
import { setRegisterStep } from "../../../redux/features/find-a-job/reducers/authReducer";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {
  fetchfreelancerProfile,
  profileStep1Submit,
} from "../../../redux/features/find-a-job/actions/authAction";
import { updateFreelancerFormData } from "../../../utils/pip";
import StepsDots from "../../form/StepsDots";
import { useEffect, useState } from "react";

const ProfileSetupStep1 = () => {
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const [profileData, setProfileData] = useState({});
  const [savedData, setSavedData] = useState({});
  const currencyOptions = [
    { label: "Euro (€)", value: "€" },
    { label: "US Dollar ($)", value: "$" },
    { label: "Mauritian Rupee (MUR)", value: "MUR" },
    { label: "Indian Rupee (INR)", value: "INR" },
    { label: "British Pound (£)", value: "£" },
    { label: "Australian Dollar (AUD)", value: "AUD" },
    { label: "Canadian Dollar (CAD)", value: "CAD" },
    { label: "Chinese Yuan (CNY)", value: "CNY" },
    { label: "UAE Dirham (AED)", value: "AED" },
  ];

  useEffect(() => {
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data || {};
      const openTalent = data?.open_talent || {};
      setProfileData(data);
      setSavedData({
        phone_number: data?.phone_number || "",
        country: openTalent?.country || "",
        city: openTalent?.city || "",
        linkedin_profile: openTalent?.linkedin_profile || "",
        portfolio_website: openTalent?.website_or_portfolio || "",
        bio: openTalent?.bio || "",
        currency: openTalent?.currency || ""
      });
    });
  }, [dispatch]);

  const normalizePhoneValue = (value) => {
    if (!value) return "";
    const trimmed = String(value).trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("+")) return trimmed;
    const digits = trimmed.replace(/\D/g, "");
    if (!digits) return "";
    return `+${digits}`;
  };

  const handleStep1 = (values) => {
    updateFreelancerFormData("profileStep1", values);
    const resolvedFullName =
      profileData?.full_name ||
      `${profileData?.first_name || ""} ${profileData?.last_name || ""}`.trim() ||
      "";

    const payload = {
      full_name: resolvedFullName,
      phone_number: values?.phone_number || "",
      country: values?.country || "",
      city: values?.city || "",
      linkedin_profile: values?.linkedin_profile || "",
      website_or_portfolio: values?.portfolio_website || "",
      bio: values?.bio || "",
      currency: values?.currency || ""
    };

    const callback = (response) => {
      if (!response?.success) return;
      dispatch(setRegisterStep("profileStep2"));
    };

    dispatch(profileStep1Submit({ payload, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/setp_3_freelance_img_left.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                    Welcome to Nuvio! Let’s Get Started
                  </h2>
                  <p className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto">
                    Fill in the basics so we can set things up just right for
                    you.
                  </p>
                </div>
                <Formik
                  initialValues={{
                    phone_number: savedData?.phone_number || "",
                    country: savedData?.country || "",
                    city: savedData?.city || "",
                    linkedin_profile: savedData?.linkedin_profile || "",
                    portfolio_website: savedData?.portfolio_website || "",
                    bio: savedData?.bio || "",
                    currency: savedData?.currency || ""
                  }}
                  validationSchema={profileStep1Schema}
                  enableReinitialize
                  onSubmit={(values, actions) => {
                    handleStep1(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setFieldError,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_mt_40">
                      <div className="row">
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Full Name
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="Full Name"
                              type="text"
                              value={profileData?.full_name || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Email Address
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="Email Address"
                              type="email"
                              value={profileData?.email || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Phone Number
                            </label>
                            <PhoneInput
                              id="phone_number"
                              className="form-control ct_input"
                              defaultCountry="MU"
                              value={normalizePhoneValue(values?.phone_number)}
                              onChange={(val) => {
                                const safeVal = val ?? "";
                                if (
                                  typeof safeVal === "string" &&
                                  safeVal.length > 2 &&
                                  isValidPhoneNumber(safeVal)
                                ) {
                                  setFieldValue("phone_number", safeVal);
                                } else {
                                  setFieldValue("phone_number", safeVal);
                                }
                              }}
                              onBlur={() => {
                                if (
                                  values?.phone_number &&
                                  !isValidPhoneNumber(values.phone_number)
                                ) {
                                  setFieldError(
                                    "phone_number",
                                    "Please enter valid phone number"
                                  );
                                }
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="phone_number"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Country
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="Country"
                              type="text"
                              id="country"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.country}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="country"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              City
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="City"
                              type="text"
                              id="city"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.city}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="city"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Currency
                            </label>
                            <div className="d-flex flex-column gap-2 position-relative">
                              <select
                                className="form-control ct_input"
                                value={values.currency}
                                onChange={(e) => setFieldValue("currency", e.target.value)}
                              >
                                <option value="">Select Currency</option>
                                {currencyOptions.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="currency"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              LinkedIn Profile
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="LinkedIn Profile"
                              type="text"
                              id="linkedin_profile"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.linkedin_profile}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="linkedin_profile"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Portfolio (Optional)
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="Portfolio"
                              type="text"
                              id="portfolio_website"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.portfolio_website}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="portfolio_website"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              About Me
                            </label>
                            <textarea
                              class="form-control ct_input h-auto"
                              rows={4}
                              placeholder="About Me"
                              type="text"
                              id="bio"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.bio}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="bio"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-2">
                        <button
                          type="submit"
                          // onClick={(e) => goTo(e, coachPaths.CoachSignUpStep2)}
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Continue
                        </button>
                      </div>
                      <StepsDots steps={[1, 2, 3, 4]} activeStep={1} />
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSetupStep1;
